import { computed, defineComponent, reactive, watch } from "vue";
import { api, SeikyuInfo } from "~/api";
import { Log } from "~/extensions/utils";
import BukenRoomList from "~/components/BukenRoomList.vue";
import { FileInfo } from "~/api/data/FileInfo";
import { SetFileInfo } from "~/api/data/SetFileInfo";
import { myPageStore } from "~/store/MyPageStore";
import { MsgBox } from "~/components/MsgBox";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { commonStore } from "~/store/CommonStore";
import { PageID } from "~/extensions/utils/DefineTypes";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
const log = Log.create("SeikyuInfoPage");
export default defineComponent({
    name: "SeikyuInfoPage",
    components: {
        BukenRoomList,
        BreadcrumbList
    },
    setup() {
        let setFileInfo = new SetFileInfo();
        const data = reactive(new SeikyuInfo());
        const nyukyokeiyaku = computed(() => myPageStore.selectedNyukyokeiyaku);
        // 画面名取得
        const pageName = commonStore.pageName(PageID.seikyu);
        const initView = async () => {
            await fetchSeikyuInfo();
        };
        watch(() => myPageStore.selectedNyukyokeiyakuNo, async (newVal) => {
            if (!isNullOrUndefined(newVal) && newVal !== -1) {
                try {
                    await fetchSeikyuInfo();
                }
                catch (e) {
                    MsgBox.error(e.message);
                }
            }
        });
        const fetchSeikyuInfo = async () => {
            try {
                Loading.show();
                // データ取得
                let result = await api.seikyuInfo.find(nyukyokeiyaku.value.orgNyukyokeiyakuNo);
                data.azukariZandaka = result.azukariZandaka;
                data.mishukinTotal = result.mishukinTotal;
                data.seikyuMeisaiList = result.seikyuMeisaiList;
            }
            catch (ex) {
                log.error("apply", ex);
                MsgBox.error(ex.message);
            }
            finally {
                Loading.hide();
            }
        };
        initView();
        return {
            data,
            FileInfo,
            setFileInfo,
            myPageStore,
            nyukyokeiyaku,
            pageName,
            PageID
        };
    }
});
